import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { faDiamondTurnRight } from '@fortawesome/free-solid-svg-icons'

const PopUpMessage = ({ errorMessage, statusCode }) => {

    if (errorMessage !== null && errorMessage !== undefined) {

        if (statusCode !== null && statusCode !== undefined) {
            var warningIcon;
            var messageIconColor;
            if (statusCode < 300 && statusCode >= 200) {
                warningIcon = faCircleCheck;
                messageIconColor = "text-green-400 text-[20px] absolute right-[20px] top-[20px] leading-[full]";
            } else if (statusCode < 200 && statusCode > 99) {
                warningIcon = faTriangleExclamation;
                messageIconColor = "text-yellow-400 text-[20px] absolute right-[20px] top-[20px] leading-[full]"
            }
            else if (statusCode < 600 && statusCode >= 500) {
                warningIcon = faCircleExclamation;
                messageIconColor = "text-yellow-400 text-[20px] absolute right-[20px] top-[20px] leading-[full]"
            }
            else if (statusCode < 500 && statusCode >= 400) {
                warningIcon = faCircleExclamation;
                messageIconColor = "text-red-400 text-[20px] absolute right-[20px] top-[20px] leading-[full]"
            }
            else if (statusCode < 400 && statusCode >= 300) {
                warningIcon = faDiamondTurnRight;
                messageIconColor = "text-blue-400 text-[20px] absolute right-[20px] top-[20px] leading-[full]"
            }
            else {
                warningIcon = faCircleInfo;
                messageIconColor = "text-black-400 text-[20px] absolute right-[20px] top-[20px] leading-[full]";
            }

        }

        return (
            <div className="shadow-lg max-w-[350px] absolute top-[2vh] right-[2vh] bg-[#ffffff] rounded text-[12px] text-gray-600 p-[20px] pr-[50px] flex justify-center align-center leading-[20px] z-50">
                {errorMessage}!<b className={messageIconColor}><FontAwesomeIcon icon={warningIcon} /></b>
                <FontAwesomeIcon icon={faCircleXmark} onClick={() => PopUpMessage} className="hover:cursor-pointer hover:text-gray-800 tra bg-[#ffffff] rounded-full absolute top-[-8px] right-[-8px] text-[20px] text-gray-600 shadow-lg" /></div >
        );
    }
}
export default PopUpMessage